import RegisterTemplate from "./register-template";
export default RegisterTemplate;